// types
import { createSlice } from '@reduxjs/toolkit';

export type DetailDrawerProps = {
  open: boolean;
};

// initial state
const initialState: DetailDrawerProps = {
  open: true,
};

// ==============================|| SLICE - DETAIL DRAWER ||============================== //

const detailDrawer = createSlice({
  name: 'detailDrawer',
  initialState,
  reducers: {
    setDetailDrawer(state, action) {
      state.open = action.payload;
    },
  },
});

export default detailDrawer.reducer;

export const { setDetailDrawer } = detailDrawer.actions;
